import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cvMapFilter',
    standalone: true
})
export class CvMapFilterPipe implements PipeTransform {
    transform(secondaryFilterMap, ...args: any[]): any {
        // const filters = secondaryFilterMap[args[0].entryType];
        const secondaryMap =  args[0]?.primaryFilter?.map(primaryFilter => {
            return { primary: primaryFilter, secondaryList: secondaryFilterMap[primaryFilter]}
        })
        return secondaryMap;
    }
}
